import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from 'vue';
import { useDashboard } from '@/views/dashboard/dashboard.provider';
import { useDashboardChartUtils } from '@/views/dashboard/dashboard.charts.utils';
import totalWorkloadsChart from './total-workloads-chart.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'total-workloads-chart-controller',
  setup(__props) {

const dashboardChartUtils = useDashboardChartUtils();
const totalWorkloadsChartConfig = useDashboard().workloads.totalWorkloadsChart;
const options = computed(() => ({
  ...totalWorkloadsChartConfig.value.options,
  toolbox: {
    feature: {
      myTool1: dashboardChartUtils.options.toolbox.feature.maximize({
        chartOptions: totalWorkloadsChartConfig,
        chartId: totalWorkloadsChartConfig.value.chartId,
        componentInstance: totalWorkloadsChart,
      }),
    },
  },
}));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(totalWorkloadsChart, {
    "chart-options": {
      ..._unref(totalWorkloadsChartConfig),
      options: _unref(options),
    }
  }, null, 8, ["chart-options"]))
}
}

})